import { atom } from 'recoil';

const calculatorQuickStylesState = atom({
  key: 'calculatorQuickStylesState',
  default: {},
});

export default calculatorQuickStylesState;
